import React, { useEffect  } from 'react';

const Adnimation = (props) => {
    
    return (
        <div className="adunit">
          { (props.height > 50) && ( <div data-onpage="true" data-adpath="/339474670,22847485332/02WS/Desktop_300x250"></div> )  }  
          {(props.height <= 50 && props.format == 'a') && (<div data-onpage="true" data-adpath="/339474670,22847485332/02WS/Mobile_320x50_a"></div>)    } 
          {(props.height <= 50 && props.format == 'b') && (<div data-onpage="true" data-adpath="/339474670,22847485332/02WS/Mobile_320x50_b"></div>)    }   
        </div>
      );
}

export default Adnimation; 